module.exports = __webpack_public_path__ + "static/media/logo.1268050c.png";